import { styles } from "./shared";
import { trackEvent } from "./shared";

export default function Footer() {
  return (
    <>
      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <div style={styles.logo}>
            <span style={styles.logoMain}>NEKRETNINE</span><span style={styles.logoYear}>U ŠPANIJI</span>
          </div>
          <p style={styles.footerText}>© 2026 Nekretnine u Španiji. Sva prava zadržana.</p>
          <p style={styles.footerText}>Prodaja novogradnje · Španija</p>
        </div>
      </footer>

      <a
        href="https://wa.me/34658372004?text=Zdravo%2C%20zanima%20me%20nekretnina%20u%20%C5%A0paniji"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.whatsappFab}
        className="whatsapp-fab"
        aria-label="Pošaljite nam poruku na WhatsApp"
        onClick={() => trackEvent("generate_lead", { method: "whatsapp" })}
      >
        <svg width="30" height="30" viewBox="0 0 24 24" fill="#080808">
          <path d="M12 2.5A9.5 9.5 0 0 0 3.6 17L2.5 21.5l4.6-1.2A9.5 9.5 0 1 0 12 2.5Zm5.5 13.6c-.2.6-1.3 1.2-1.9 1.3-.5.1-1.1.1-1.8-.1-.4-.1-1-.3-1.7-.6-3-1.3-4.9-4.3-5.1-4.5-.1-.2-1.2-1.6-1.2-3.1s.8-2.2 1-2.5c.3-.3.6-.4.8-.4h.6c.2 0 .4 0 .6.5.2.6.7 1.9.8 2.1.1.2.1.4 0 .6-.1.2-.2.4-.4.6-.2.2-.4.5-.6.6-.2.2-.4.4-.2.7.2.3.9 1.4 1.9 2.3 1.3 1.2 2.4 1.5 2.7 1.7.3.2.5.1.7-.1.2-.2.8-.9 1-1.2.2-.3.4-.2.7-.1.3.1 1.8.9 2.1 1 .3.2.5.2.6.3.1.2.1.7-.1 1.3Z"/>
        </svg>
      </a>
    </>
  );
}
